import { render, staticRenderFns } from "./PatientSurveys.vue?vue&type=template&id=63d46a9d"
import script from "./PatientSurveys.vue?vue&type=script&lang=js"
export * from "./PatientSurveys.vue?vue&type=script&lang=js"
import style0 from "./PatientSurveys.vue?vue&type=style&index=0&id=63d46a9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports